import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { PageTransitionService } from '../../services/page-transition.service';

// Full-screen fade overlay shown while a language switch loads or while
// navigating between two public marketing pages, so either reads as a
// deliberate transition rather than a stall. Mounted once in app.component.html,
// outside <ion-app> (same reasoning as the dropdown panels there: a fixed
// full-viewport layer must sit outside any backdrop-filter containing block).
@Component({
    selector: 'app-page-transition-overlay',
    templateUrl: './page-transition-overlay.component.html',
    styleUrls: ['./page-transition-overlay.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe],
})
export class PageTransitionOverlayComponent implements OnInit, OnDestroy {
  visible = false;
  isClosing = false;
  showProgress = false;

  private subscription?: Subscription;
  private hideTimeout: ReturnType<typeof setTimeout> | undefined;

  constructor(
    private readonly transition: PageTransitionService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.subscription = this.transition.visible$.subscribe(show => {
      clearTimeout(this.hideTimeout);

      if (show) {
        this.visible = true;
        this.isClosing = false;
        this.showProgress = this.transition.progressActive;
        this.cdr.markForCheck();
        return;
      }

      // Play the fade-out before removing the overlay from the DOM. Must match
      // the fade-out animation duration in the stylesheet.
      this.isClosing = true;
      this.cdr.markForCheck();
      this.hideTimeout = setTimeout(() => {
        this.visible = false;
        this.cdr.markForCheck();
      }, 400);
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    clearTimeout(this.hideTimeout);
  }
}
